import React from 'react';
import Helmet from 'react-helmet';

const StructuredData = () => {
  const today = new Date();
  const todayISO = today.toISOString();
  return (
    <Helmet>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.pbs.org/wgbh/frontline/interactive/ap-russia-war-crimes-ukraine/"
            },
            "headline": "AP News and FRONTLINE PBS are documenting incidents involving potential war crimes in Ukraine",
            "description": "The Associated Press and FRONTLINE are gathering, verifying and documenting evidence of potential war crimes in Ukraine, including direct attacks on civilians, and attacks on civilian infrastructure including hospitals, schools, residential areas and sites protected under international humanitarian law. We will be regularly updating War Crimes Watch Ukraine and publishing related stories.",
            "image": "https://www.pbs.org/wgbh/frontline/interactive/war-crimes-ukraine-og.png",  
            "author": [{
              "@type": "Organization",
              "name": "AP NEWS",
              "url": "https://apnews.com"
            }, {
              "@type": "Organization",
              "name": "FRONTLINE PBS",
              "url": "https://www.pbs.org/wgbh/frontline/"
            }
            ],  
            "publisher": {
              "@type": "Organization",
              "name": "FRONTLINE PBS",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.pbs.org/wgbh/frontline/wp-content/themes/fl-responsive-theme/library/images/frontline_logo_og.png"
              }
            },
            "datePublished": "2022-05-25T17:00:00.000Z",
            "dateModified": "${todayISO}"
          }
      `}
      </script>
    </Helmet>
  );
};

export default StructuredData;
